<template>
  <div class="first-form-section">
    <div class="container">
      <div
        class="application-status-block"
        :style="applicationColors"
      >
        <div class="header-info" style="width: 100%">
        <div class="application-status-number-and-date-flex">
          <span><b>№{{ application.number }}</b></span>
          <span><b v-html="this.applicationPeriodTitle"></b></span>
        </div>
        <div class="header-info-status">
          <span><b>{{ applicationStatus.name }}</b></span>
        </div>
        </div>
        <div
          v-if="dropDownNotEmpty"
          id="dropdown"
          class="dropdown application-status-block-button"
          v-click-outside="hide"
        >
          <a
            data-toggle="dropdown"
            class="application-action btn btn-default dropdown-toggle"
            @mousedown="collapse"
          >
            <i class="fa fa-bars"></i>
          </a>
          <ul
            class="dropdown-menu"
            ref="dropdown"
          >
            <slot name="prevItems"></slot>
            <li
              v-for="(item, key) in actions"
              :key="key"
            >
              <a
                :style="{cursor: 'pointer'}"
                v-on:click="item.esignature === '1' ? getSigner(application, item) : approvalCommand(application, item)"
              >
                <img
                  class="menu-item-img"
                  :src="iconsPath + item.icon"
                  width="20px"
                  height="22px"
                  alt=""
                />
                {{ item.command_name }}
              </a>
            </li>
            <slot name="lastItems"></slot>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import moment from 'moment-timezone';

export default {
  name: 'application-status-info-block',

  directives: {
    ClickOutside
  },

  props: {
    actions: {
      type: Array,
      default: () => []
    },
    application: {
      type: Object,
      default: Object
    },
    applicationStatus: {
      type: Object,
      default: Object
    },
    approvalCommand: Function,
    canViewThereButtons: Boolean,
    getSigner: Function
  },

  computed: {
    applicationColors() {
      return {
        'background-color': this.applicationStatus.bg_color + ' !important',
        'border-color': this.applicationStatus.ln_color + ' !important'
      }
    },

    applicationPeriodTitle() {
      const outputFormat = 'DD.MM.YYYY';
      const application = this.application;
      const periodTo = moment.tz(application.period_to, outputFormat, this.timezone).format(outputFormat);
      const periodOf = moment.tz(application.period_of, outputFormat, this.timezone).format(outputFormat);

      if (!application.period_of) {
        return ''
      }
      if (!application.period_to) {
        return ' с ' + periodOf
      }

      return '<wbr> с&nbsp' + periodOf + '&nbspпо&nbsp' + periodTo
    },

    dropDownNotEmpty() {
      return this.actions.length > 0 || this.canViewThereButtons
    },

    iconsPath() {
      return process.env.BASE_URL + '/img/icons/statuses/'
    },

    multiDayApplication() {
      return this.application.period_of !== this.application.period_to
    }
  },

  methods: {
    collapse() {
      let el = document.getElementById('dropdown')
      el.classList.toggle('open')
    },

    hide() {
      let el = document.getElementById('dropdown')
      el.classList.remove('open')
    }
  }
}
</script>
